<template>
  <Wrapper
      code="delivery_courier"
      :icon="ICONS.delivery"
      :model-value="attrs.ADDRESS"
      @open="onClick"
      label="Адрес доставки"
  >
    {{ attrs.ADDRESS }}
  </Wrapper>
</template>

<script lang="ts" setup>

import {VOrderSectionProps, vorderSectionPropsDefault} from "./util";
import Wrapper from "./Wrapper/Wrapper.vue";
import {storeToRefs} from "pinia";
import {ICONS} from "@/assets/icons";
import {useRouter} from "vue-router";
import {useVorderState} from "@/modules/shop/store/vorder-state";

const vorderState = useVorderState()
const {attrs} = storeToRefs(vorderState)

const props = withDefaults(defineProps<VOrderSectionProps>(), {
  ...vorderSectionPropsDefault,
})

const router = useRouter()

const onClick = () => {
  router.push('/delivery-service?role=vorder&type=profile')
}

</script>

<style>

</style>
